import React from 'react'
import { Alert, Select } from 'antd'
import { useFetchDisciplinesQuery } from '../../../../store/apis/discipline.api'
import { renderOptionWithDescription } from '../../../../utils/antd.helper'

const ConceptualLabelSelectDisciplines = ({ includeSystem = true, ...rest }) => {
    const { data: disciplines, isFetching: isFetchingDisciplines, error: disciplinesError } = useFetchDisciplinesQuery({
        includeInactive: false,
        includeSystem
    })

    const disciplineOptions = disciplines?.map(discipline => ({
        label: discipline.visualId ? `${discipline.visualId} - ${discipline.name}` : discipline.name,
        value: discipline.id,
        description: discipline.description,
        title: `${discipline.visualId} - ${discipline.name} - ${discipline.description}`,
    }))

    return (
        <>
            <Select
                allowClear
                style={{ width: '100%' }}
                options={disciplineOptions}
                loading={isFetchingDisciplines}
                showSearch
                optionFilterProp='label'
                popupMatchSelectWidth={false}
                getPopupContainer={triggerNode => triggerNode.parentNode}
                optionRender={renderOptionWithDescription}
                {...rest}
            />
            {disciplinesError && <Alert message={disciplinesError} type='error' showIcon closable />}
        </>
    )
}

export default ConceptualLabelSelectDisciplines
